import { api } from '@/api';

export interface PermissionApiModel {
  uuid: string;
  permission_name: string;
  description: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface PermissionsListPayload {
  count: number;
  next: string | null;
  previous: string | null;
  results: PermissionApiModel[];
}

export const permissionsService = {
  async list(page: number = 1, pageSize: number = 15, search?: string): Promise<PermissionsListPayload> {
    const params = new URLSearchParams({
      page: page.toString(),
      page_size: pageSize.toString(),
    });
    
    if (search && search.trim()) {
      params.append('search', search.trim());
    }
    
    const response = await api.get<PermissionsListPayload>(`/backoffice/api/v1/permissions/?${params.toString()}`);
    // The API returns data directly, not wrapped in ApiResponse
    return response as unknown as PermissionsListPayload;
  },
  async create(payload: { permission_name: string; description: string }): Promise<unknown> {
    return api.post<unknown>('/backoffice/api/v1/permissions/', payload);
  },
  async update(uuid: string, payload: { permission_name: string; description: string }): Promise<unknown> {
    return api.patch<unknown>(`/backoffice/api/v1/permission-details/${uuid}/`, payload);
  },
  async toggleActive(uuid: string, is_active: boolean): Promise<unknown> {
    return api.put<unknown>(`/backoffice/api/v1/permission-details/${uuid}/`, { is_active: is_active });
  },
  async delete(uuid: string): Promise<unknown> {
    return api.delete<unknown>(`/backoffice/api/v1/permission-details/${uuid}/`);
  },
};

export default permissionsService;


